var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegislation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.353,
    height: 15,
    viewBox: "0 0 12.353 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_20585",
    "data-name": "Raggruppa 20585",
    transform: "translate(21370.354 6529.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32880",
    "data-name": "Tracciato 32880",
    d: "M27.646,208.985c0-1.664,0-2.5.517-3.012s1.349-.517,3.013-.517h5.293c1.664,0,2.5,0,3.013.517s.517,1.348.517,3.012v7.941c0,1.664,0,2.5-.517,3.013s-1.349.517-3.013.517H31.176c-1.664,0-2.5,0-3.013-.517s-.517-1.349-.517-3.013Z",
    transform: "translate(-21398 -6735)",
    fill: "#3260ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32882",
    "data-name": "Tracciato 32882",
    d: "M33.063,213h5.294v-1.324H33.063Zm5.294,0a.662.662,0,0,0,0-1.324Zm-5.294-1.324a.662.662,0,0,0,0,1.324Z",
    transform: "translate(-21399.887 -6737.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32883",
    "data-name": "Tracciato 32883",
    d: "M33.063,218.85h5.294v-1.324H33.063Zm5.294,0a.662.662,0,0,0,0-1.324Zm-5.294-1.324a.662.662,0,0,0,0,1.324Z",
    transform: "translate(-21399.887 -6739.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32884",
    "data-name": "Tracciato 32884",
    d: "M33.063,224.7h3.53v-1.324h-3.53Zm3.53,0a.662.662,0,0,0,0-1.324Zm-3.53-1.324a.662.662,0,0,0,0,1.324Z",
    transform: "translate(-21399.887 -6742.115)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegislation);
export default __webpack_public_path__ + "static/media/legislation.29fa1e38651b57eb605cdc61191af3c2.svg";
export { ForwardRef as ReactComponent };